const state = {
    tab: {
        current: false,
        last: false
    },
};

const actions = {
    showTab({commit, dispatch}, name) {
        commit('SET_TAB', name);
    },
    hideTab({commit, dispatch}) {
        commit('HIDE_TAB');
    },
    saveLastTab({commit, dispatch}) {
        commit('SET_LAST_TAB');
    }
};

const mutations = {
    SET_TAB(state, name) {
        if (!name) {
            state.tab.current = !state.tab.current ? state.tab.last : false;
        }
        else {
            state.tab.current = state.tab.last = name;
        }
    },
    HIDE_TAB(state) {
        state.tab.current = false;
    },
    SET_LAST_TAB(state) {
        state.lastTab = 'channels';
    }
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js